module.exports = __webpack_public_path__ + "img/trushenko.ea57def0.jpg";